import React from 'react'
import ModalDrawer from '../../../../../common/components/organisme/ModalDrawer/ModalDrawer'
import NewChargePointFormPresenter from '../NewChargePointForm/NewChargePointFormPresenter'
import useQueryURL from '../../../../../common/hooks/useQueryURL'

export default function NewChargePointFormModal({modalId}:{modalId?: string}) {

    const{removeQueryValue} =useQueryURL()
    const closeModal = () => {
        removeQueryValue([modalId || "add-new-charge-point-modal"])
    
    }

  return (
    <ModalDrawer urlParamName={modalId || "add-new-charge-point-modal"} title='Nouvelle borne'>
        <NewChargePointFormPresenter onSuccess={closeModal}  />
    </ModalDrawer>
  )
}
